import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {IconsModule} from '../../services/icons.module';
import {NotificationModule} from '../../components/dumb/notification/notification.module';
import {NotificationsDrawerComponent} from './notifications-drawer.component';
import {NotificationManagerComponent} from './notification-manager/notification-manager.component';
import {SlackNotificationComponent} from './slack-notification/slack-notification.component';
import {DrawerModule} from '../../components/smart/drawer/drawer.module';

@NgModule({
  declarations: [NotificationsDrawerComponent, NotificationManagerComponent, SlackNotificationComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, IconsModule, NotificationModule, DrawerModule],
  exports: [NotificationsDrawerComponent],
})
export class NotificationsDrawerModule {}
